
import { Component, Prop, Mixins } from 'vue-property-decorator';
import { BAIconsMixin, ColorsMixin, VuetifyMixin } from '@/mixins';
import { TeamJersey } from '@/models/team';
import { cloneDeep } from 'lodash';
import { isNotEmpty } from '@/pipes';
import { wait } from '@/helpers';

interface VueColor {
  hex: string;
  rgba: { r: number; g: number; b: number; a: number };
  hsl: { h: number; s: number; l: number; a: number };
  [key: string]: any; // To account for other possible color representations
}

@Component({
    components: {}
})
export default class JerseyEditColor extends Mixins(VuetifyMixin, BAIconsMixin, ColorsMixin) {
    @Prop() value: TeamJersey;
    @Prop() playerNumber: string;
    @Prop({ type: Boolean }) noEdit;
    
    editingColors: boolean = false;
    editingJerseyColor: boolean = false;
    editingJerseyAccent: boolean = false;
    editingJerseyNumber: boolean = false;
    updatingColor: boolean = false;

	vueColorJersey: VueColor = {
		hex: '#194d33',
	    rgba: { r: 25, g: 77, b: 51, a: 1 },
    	hsl: { h: 146, s: 49, l: 20, a: 1 }
	};
	vueColorAccent: VueColor = {
		hex: '#ffffff',
	    rgba: { r: 25, g: 77, b: 51, a: 1 },
    	hsl: { h: 146, s: 49, l: 20, a: 1 }
	};
	vueColorNumber: VueColor = {
		hex: '#ffffff',
	    rgba: { r: 25, g: 77, b: 51, a: 1 },
    	hsl: { h: 146, s: 49, l: 20, a: 1 }
	};

    get PlayerNumber(): string {
        if( isNotEmpty(this.playerNumber) ) return this.playerNumber;
        return '7';
    }

    backupJersey: TeamJersey;
    onEditJersey() {
        if( this.noEdit ) return;
        
        this.$emit('editStart', this.value);
        this.backupJersey = cloneDeep(this.value);
        this.vueColorJersey.hex = this.value.color;
        this.vueColorAccent.hex = this.value.accent;
        this.vueColorNumber.hex = this.value.number;
        this.editingColors = true;
    }
    onCancelEditJersey() {
        this.value = cloneDeep(this.backupJersey);
        this.$emit('cancel', this.value);
        this.editingJerseyColor = false;
        this.editingJerseyAccent = false;
        this.editingJerseyNumber = false;
        this.moreColors = false;
        this.editingColors = false;
    }
    onEditJerseyComplete() {
        this.$emit('input', this.value);
        this.$emit('change', this.value);
        this.editingColors = false;
    }
    async onChangeJerseyColorDone(newColor: string) {
        this.updatingColor = true;
		this.value.color = newColor;
        this.editingJerseyColor = false;
        this.moreColors = false;
        await wait(1);
        this.updatingColor = false;
    }
	onChangeJerseyColor(newColor: VueColor) {
        this.onChangeJerseyColorDone(newColor.hex);
	}
    async onChangeAccentColorDone(newColor: string) {
        this.updatingColor = true;
		this.value.accent = newColor;
        this.editingJerseyAccent = false;
        this.moreColors = false;
        await wait(1);
        this.updatingColor = false;
    }
	onChangeAccentColor(newColor: VueColor) {
		this.onChangeAccentColorDone(newColor.hex);
	}
    async onChangeNumberColorDone(newColor: string) {
        this.updatingColor = true;
		this.value.number = newColor;
        this.editingJerseyNumber = false;
        this.moreColors = false;
        await wait(1);
        this.updatingColor = false;
    }
	onChangeNumberColor(newColor: VueColor) {
		this.onChangeNumberColorDone(newColor.hex);
	}
    onEditJerseyColor() {
        if( this.noEdit ) return;
        this.editingJerseyColor = true;
    }
    onEditJerseyAccent() {
        if( this.noEdit ) return;
        this.editingJerseyAccent = true;
    }
    onEditJerseyNumber() {
        if( this.noEdit ) return;
        this.editingJerseyNumber = true;
    }
}
